const Home = () => import(/* webpackChunkName: "feelgrid" */ './Home.vue');
const Grid = () => import(/* webpackChunkName: "feelgrid" */ './Grid.vue');
const NewGrid = () => import(/* webpackChunkName: "feelgrid" */ './NewGrid.vue');
const Orders = () => import(/* webpackChunkName: "feelgrid" */ './Orders.vue');
const NewOrder = () => import(/* webpackChunkName: "feelgrid" */ './orders/NewOrder.vue');
const Main = () => import(/* webpackChunkName: "feelgrid" */ './grid/Main.vue');
const Order = () => import(/* webpackChunkName: "feelgrid" */ './orders/Order.vue');
const Invoice = () => import(/* webpackChunkName: "feelgrid" */ './orders/Invoice.vue');
const Devices = () => import(/* webpackChunkName: "feelgrid" */ './Devices.vue');
const Device = () => import(/* webpackChunkName: "feelgrid" */ './devices/Device.vue');

var Base = {
  template: '<router-view :gateways=gateways />',
    asyncComputed: {
      gateways () {
        return this.async('apptoken')
          .then(token => this.api.get(
            'gateways' +
              '?include=locations,hardware_types' +
              '&range=max' +
              '&filter=apptokens_id::eq::' + token.id
          ))
        ;
      },
    },
};

export const routes = [
{
  path: 'feelgrid',
  name: 'feelgrid',
  redirect: {name: 'feelgrid.grids'},
  component: Base,
  meta: {
    trans: 'feelgrid:title',
    root: true,
  },
  children: [
    {
      path: 'grids',
      name: 'feelgrid.grids',
      component: Home,
      meta: {
        trans: 'feelgrid:titles.home',
        icon: 'visible',
      },
    },
    {
      path: 'new',
      name: 'feelgrid.new',
      component: NewGrid,
      meta: {
        trans: 'feelgrid:new_grid.title',
        menu: false,
      },
    },
    {
      path: 'grids/:id',
      name: 'feelgrid.grid',
      component: Grid,
      redirect: {name: 'feelgrid.grid.main'},
      props: true,
      meta: {
        trans: 'feelgrid:titles.grid',
        menu: false,
        root: true,
      },
      children: [
        {
          path: 'view',
          name: 'feelgrid.grid.main',
          component: Main,
          props: true,
          meta: {
          },
        },
        {
          path: 'order',
          name: 'feelgrid.orders.new',
          component: NewOrder,
          meta: {
            trans: 'feelgrid:new_order.title',
            root: true,
            menu: false,
          },
        },
      ],
    },
    {
      path: 'orders',
      name: 'feelgrid.orders',
      component: Orders,
      meta: {
        trans: 'feelgrid:titles.billing',
        icon: 'dollar',
      },
    },
    {
      path: 'orders/:id',
      name: 'feelgrid.orders.order',
      component: Order,
      props: true,
      meta: {
        trans: 'feelgrid:titles.billing',
        up: 'feelgrid.orders',
      },
      children: [{
        path: 'invoice',
        name: 'feelgrid.orders.order.invoice',
        component: Invoice,
        meta: {
          trans: 'feelgrid:titles.billing',
        },
      }],
    },
    {
      path: 'devices',
      name: 'feelgrid.devices',
      component: Devices,
      meta: {
        trans: 'feelgrid:titles.devices',
        icon: 'emitter',
      },
    },
    {
      path: 'devices/:id',
      name: 'feelgrid.devices.device',
      component: Device,
      props: true,
      meta: {
        trans: 'feelgrid:titles.device',
        up: 'feelgrid.devices',
      },
    },
  ],
}
];

// TRANSLATIONS
import en from './i18n/en'
import i18n from '@/providers/i18n'

import {translations as modules_translations} from './modules'

var en_extended = Object.assign({}, modules_translations.en, en);

for (let [lang, bundle] of Object.entries({
  en: en_extended,
})) {
  i18n.i18next.addResourceBundle(lang, 'feelgrid', bundle);
}

import maps from '@/providers/maps'

export function guard(router) {
  router.afterEach((to, from) => {
    if (to.name && to.name.split('.')[0] === 'feelgrid') {
      import(/* webpackChunkName: "feelgrid" */ './scss/style.scss');
    }
  });
  //load google maps API before entering FellGrid
  router.beforeEach((to, from, next) => {
    if (to.name && to.name.split('.')[0] === 'feelgrid') {
      return maps.then(() => next());
    } else {
      return next();
    }
  });
}


// WEBPACK FOOTER //
// ./src/apps/feelgrid/index.js